/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { DELETE_PAY_TX } from "../graphql/deletePayTx.mutation";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDeletePayTxTypeMethods extends IPluginMethodMap {
  deletePayTx(args: any): Promise<any>;
}

export class DeletePayTxService implements IAgentPlugin {
  readonly methods: IDeletePayTxTypeMethods;

  constructor() {
    this.methods = {
      deletePayTx: this.deletePayTx.bind(this),
    };
  }

  async deletePayTx(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: DELETE_PAY_TX,
          variables: {
            filter: {
              txId: args?.txId,
              costumeID: args?.costumeID,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.deletePayTx && is.existy(res?.data?.deletePayTx)) {
          return res?.data?.deletePayTx;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
